/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.geofences.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@ExperimentalJsExport
@JsExport
@Serializable
data class GeofenceModel(
    /** A unique ID identifying this geofence */
    @SerialName("id")
    val id: Int,

    @SerialName("title")
    val title: String?,

    @SerialName("latitude")
    val latitude: Double?,

    @SerialName("longitude")
    val longitude: Double?,

    @SerialName("radius")
    val radius: Double?,

    @SerialName("track")
    val track: Boolean?,

    @SerialName("use_exact_address")
    val useExactAddress: Boolean?,

    @SerialName("active")
    val active: Boolean?,

    @SerialName("status")
    val status: String?,

    @SerialName("linked_campaigns")
    val linkedCampaigns: List<Int>?,

    @SerialName("created_at")
    val createdAt: String?
) : Model()
